import React, { useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import environment from '../../lib/RelayUtils';
import { commit } from './mutations/ConfigurableBlockEdit';
import { commit as deleteCommit } from './mutations/ConfigurableBlockDelete';
import { ConfigurableBlockForm } from './ConfigurableBlockForm';
import { createFragmentContainer, graphql } from 'react-relay';
import RaisedButton from 'material-ui/RaisedButton';

const bodyStyle = { backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' };

const ConfigurableBlockEdit = props => {
	const {
		history,
		viewer,
		match: { params },
	} = props;
	const [snackbarMessage, setSnackbarMessage] = useState(undefined);
	const { configurableBlock } = viewer;

	const linked = useMemo(() => {
		if (!configurableBlock) return [];
		if (configurableBlock.type === 'listNews') {
			const linked = configurableBlock.config.linked;
			const articles = linked ? JSON.parse(linked) : [];
			return articles.map(article => ({
				id: article.id,
				title: article.title,
				customTitle: article.customTitle,
			}));
		}
	}, [configurableBlock]);

	const initialValues = useMemo(() => {
		if (!configurableBlock) return {};
		const clone = JSON.parse(JSON.stringify(configurableBlock));
		if (configurableBlock.type === 'news') {
			if (configurableBlock.config === null) {
				clone.config = { article: [] };
			} else {
				const article = configurableBlock.config.article;
				clone.config.article = article ? [article] : [];
			}
		}
		if (configurableBlock.type === 'listNews') {
			clone.config.linked = linked;
		}
		return clone;
	}, [configurableBlock, linked]);

	const onSubmit = data => {
		data.id = configurableBlock ? configurableBlock.id : params.id;
		commit(environment, data, (error: ?Error) => {
			if (error) {
				setSnackbarMessage('Ошибка во время сохранения');
			} else {
				setSnackbarMessage('Пользователь успешно создан');
				history.push('/configurable-blocks');
			}
		});
	};

	const handleDelete = () => {
		const id = configurableBlock ? configurableBlock.id : params.id;
		if (confirm('Вы действитель хотите удалить релкамный блок')) {
			deleteCommit(
				environment,
				{
					id,
				},
				(error: ?Error) => {
					if (!error) {
						history.push('/configurable-blocks');
					}
				},
			);
		}
	};

	const handleCloseSnackbar = () => setSnackbarMessage(undefined);

	return (
		<Paper style={{ width: '100%', padding: 16 }}>
			<ConfigurableBlockForm initialValues={initialValues} viewer={viewer} isCreation={false} onSubmit={onSubmit}>
				<RaisedButton
					style={{
						marginLeft: 20,
					}}
					labelColor={'#ffffff'}
					onClick={handleDelete}
					backgroundColor={'#f50000'}
					label={'Удалить'}
				/>
			</ConfigurableBlockForm>
			{snackbarMessage && <Snackbar open={true} bodyStyle={bodyStyle} message={snackbarMessage} onRequestClose={handleCloseSnackbar} />}
		</Paper>
	);
};

export default withRouter(
	createFragmentContainer(
		ConfigurableBlockEdit,
		graphql`
			fragment ConfigurableBlockEdit_viewer on Viewer @argumentDefinitions(id: { type: "ID!" }) {
				...ArticleSelector_viewer
				id
				configurableBlock(id: $id) {
					id
					type
					slug
					active
					config
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/configurable-blocks/ConfigurableBlockEdit.js